export const SITE_CATEGORIES = [
  'AI & Future Tech',
  'Automobile',
  'Business & Entrepreneurship',
  'E-commerce & Startups',
  'Education & Career',
  'Entertainment & Media',
  'Environment',
  'Esports',
  'Family',
  'Fashion & Beauty',
  'Finance & Investment',
  'Food & Nutrition',
  'General',
  'Health & Fitness',
  'Home Improvement',
  'Law',
  'Lifestyle & Wellness',
  'Magazine',
  'Marketing & SEO',
  'News',
  'Others',
  'Parenting & Relationships',
  'Real Estate',
  'Sports & Fitness',
  'Sustainability & Green Living',
  'Technology & Gadgets',
  'Travel & Tourism',
] as const;

export const SITE_LANGUAGES = [
  'English',
  'Spanish',
  'French',
  'German',
  'Italian',
  'Portuguese',
  'Dutch',
  'Russian',
  'Chinese (Simplified)',
  'Chinese (Traditional)',
  'Japanese',
  'Korean',
  'Arabic',
  'Hindi',
  'Bengali',
  'Urdu',
  'Punjabi',
  'Turkish',
  'Polish',
  'Swedish',
  'Norwegian',
  'Danish',
  'Finnish',
  'Hebrew',
  'Thai',
  'Vietnamese',
  'Indonesian',
  'Malay',
  'Filipino',
  'Czech',
  'Hungarian',
  'Greek',
  'Romanian',
  'Bulgarian',
  'Croatian',
  'Slovak',
  'Slovenian',
  'Serbian',
  'Ukrainian',
  'Lithuanian',
  'Latvian',
  'Estonian'
] as const;

export const COUNTRIES = [
  'United States',
  'United Kingdom',
  'Canada',
  'Australia',
  'Germany',
  'France',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'Austria',
  'Sweden',
  'Norway',
  'Denmark',
  'Finland',
  'Ireland',
  'Portugal',
  'Poland',
  'Czech Republic',
  'Hungary',
  'Greece',
  'Turkey',
  'Russia',
  'Ukraine',
  'Romania',
  'Bulgaria',
  'Croatia',
  'Slovenia',
  'Serbia',
  'Bosnia and Herzegovina',
  'Montenegro',
  'Macedonia',
  'Albania',
  'Estonia',
  'Latvia',
  'Lithuania',
  'Belarus',
  'Moldova',
  'Slovakia',
  'Luxembourg',
  'Malta',
  'Cyprus',
  'Iceland',
  'Liechtenstein',
  'Monaco',
  'Andorra',
  'San Marino',
  'Vatican City',
  'Japan',
  'South Korea',
  'China',
  'Taiwan',
  'Hong Kong',
  'Singapore',
  'Malaysia',
  'Thailand',
  'Indonesia',
  'Philippines',
  'Vietnam',
  'India',
  'Pakistan',
  'Bangladesh',
  'Sri Lanka',
  'Nepal',
  'Bhutan',
  'Maldives',
  'Myanmar',
  'Cambodia',
  'Laos',
  'Mongolia',
  'North Korea',
  'Kazakhstan',
  'Uzbekistan',
  'Kyrgyzstan',
  'Tajikistan',
  'Turkmenistan',
  'Afghanistan',
  'Iran',
  'Iraq',
  'Syria',
  'Lebanon',
  'Jordan',
  'Israel',
  'Palestine',
  'Saudi Arabia',
  'United Arab Emirates',
  'Qatar',
  'Bahrain',
  'Kuwait',
  'Oman',
  'Yemen',
  'Egypt',
  'Libya',
  'Tunisia',
  'Algeria',
  'Morocco',
  'Western Sahara',
  'Mauritania',
  'Mali',
  'Niger',
  'Chad',
  'Sudan',
  'South Sudan',
  'Ethiopia',
  'Eritrea',
  'Djibouti',
  'Somalia',
  'Kenya',
  'Uganda',
  'Tanzania',
  'Rwanda',
  'Burundi',
  'Democratic Republic of Congo',
  'Republic of Congo',
  'Gabon',
  'Equatorial Guinea',
  'Cameroon',
  'Central African Republic',
  'Angola',
  'Zambia',
  'Zimbabwe',
  'Mozambique',
  'Madagascar',
  'Mauritius',
  'Seychelles',
  'Comoros',
  'Malawi',
  'Botswana',
  'Namibia',
  'South Africa',
  'Lesotho',
  'Swaziland',
  'Cape Verde',
  'Sao Tome and Principe',
  'Guinea-Bissau',
  'Guinea',
  'Sierra Leone',
  'Liberia',
  'Cote d\'Ivoire',
  'Ghana',
  'Togo',
  'Benin',
  'Nigeria',
  'Niger',
  'Burkina Faso',
  'Senegal',
  'Gambia',
  'Guinea-Bissau',
  'Brazil',
  'Argentina',
  'Chile',
  'Peru',
  'Colombia',
  'Venezuela',
  'Ecuador',
  'Guyana',
  'Suriname',
  'Paraguay',
  'Uruguay',
  'Bolivia',
  'Mexico',
  'Guatemala',
  'Belize',
  'Honduras',
  'El Salvador',
  'Nicaragua',
  'Costa Rica',
  'Panama',
  'Cuba',
  'Jamaica',
  'Haiti',
  'Dominican Republic',
  'Bahamas',
  'Trinidad and Tobago',
  'Barbados',
  'Saint Lucia',
  'Saint Vincent and the Grenadines',
  'Grenada',
  'Antigua and Barbuda',
  'Saint Kitts and Nevis',
  'Dominica',
  'New Zealand',
  'Fiji',
  'Papua New Guinea',
  'Solomon Islands',
  'Vanuatu',
  'Samoa',
  'Kiribati',
  'Tonga',
  'Tuvalu',
  'Nauru',
  'Marshall Islands',
  'Palau',
  'Federated States of Micronesia'
] as const;
